var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"id":"dashboard"}},[_c('p',[_vm._v("Dashboard page works!")])])}
var staticRenderFns = []

export { render, staticRenderFns }